import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 280px;
  position: absolute;
  right: 24px;
  color: #000;
`;

export const UserDisplay = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  > p {
    font-size: 12px;
    margin-right: 8px;
    ::selection {
      color: inherit;
    }
  }
  span:last-child {
    background-image: url(${require('../../../../../assets/images/small-arrow.svg')});
    display: inline-block;
    width: 16px;
    height: 16px;
    position: relative;
    top: -2px;
  }
  @media screen and (max-width: 767px) {
    > p,
    span:last-child {
      display: none;
    }
  }
`;

export const Character = styled.span`
  display: inline-block;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #efd9ff;
  position: relative;
  ::before{
    content: '${({ character }) => character}';
    color: #9000ff;
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  @media screen and (min-width: 768px){
    margin-right: 8px;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 20px;
  min-width: 256px;
  box-shadow: 0 5px 40px 0 rgba(0, 0, 0, 0.15);
  padding: 24px;
  padding-bottom: 16px;
  background-color: #fff;
  z-index: 9;
  ${Character} {
    margin-bottom: 16px;
    width: 56px;
    height: 56px;
    ::before {
      font-size: 20px;
    }
  }
  h6 {
    margin: 0;
    font-size: 14px;
    font-weight: 300;
    max-width: 208px;
    text-overflow: ellipsis;
    white-space: pre;
    overflow: hidden;
  }
  > p {
    font-size: 14px;
    color: #859099;
    font-weight: 300;
    margin-top: 6px;
    margin-bottom: 0;
    max-width: 208px;
    text-overflow: ellipsis;
    white-space: pre;
    overflow: hidden;
  }
  @media screen and (max-width: 767px) {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 9;
    background: #fff;
    margin-top: 0;
    padding-top: 48px;
  }
`;

export const Divider = styled.div`
  display: flex;
  margin-left: -72px;
  margin-right: -72px;
  flex-wrap: wrap;
  width: calc(100% + 48px);
  height: 1px;
  background-color: #e0e7ec;
  margin-top: 20px;
  margin-bottom: 8px;
`;

const BaseIcon = styled.span`
  width: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 16px;
  background-size: cover;
`;

export const LayersIcon = styled(BaseIcon)`
  background-image: url(${require('../../../../../assets/images/layers.svg')});
  height: 17px;
`;

export const LogoutIcon = styled(BaseIcon)`
  background-image: url(${require('../../../../../assets/images/logout.svg')});
`;

export const UserIcon = styled(BaseIcon)`
  background-image: url(${require('../../../../../assets/images/user-icon.svg')});
`;

export const ActionList = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  margin-left: -24px;
  margin-right: -24px;
  a {
    display: inline-block;
    padding: 16px 24px;
    font-size: 14px;
    color: #180a33;
    text-decoration: none;
    font-weight: 300;
    :hover {
      background-color: #f1f5f7;
    }
  }
`;

export const CloseButton = styled.button`
  background: url(${require('../../../../../assets/images/close-icon.svg')});
  position: absolute;
  border: 0;
  top: 20px;
  right: 24px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  @media screen and (min-width: 768px) {
    display: none;
  }
`;
